import React from 'react';
import { Table, Tooltip, Button, Tag } from 'antd';

import { DOMICILIO_FISCAL } from '../../../../common/types/tipoEstablecimientoType';

export default function DetalleListaPrecio(props) {
    return (
        <Table
            size="small"
            style={{ overflowX: 'auto' }}
            rowKey={m => m.id}
            dataSource={props.source}
            className={'table-detalle-lista-precio'}
            pagination={{
                pageSize: 10,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            title={() => (
                <div style={{ width: '100%', textAlign: "right" }}>
                    <div className="custom-options">
                        <Button
                            icon="plus"
                            type="primary"
                            onClick={props.onNew}
                            loading={props.loadingNew}
                        >
                            Nuevo
                        </Button>
                    </div>
                </div>
            )}
            columns={[
                {
                    key: 'options',
                    align: 'center',
                    width: "10px",
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={row.codigoSunatTipoEstablecimiento === DOMICILIO_FISCAL.CODIGO || !row.flag ? true : false}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Eliminar" : "Activar"}>
                                <Button
                                    disabled={row.codigoSunatTipoEstablecimiento === DOMICILIO_FISCAL.CODIGO ? true : false}
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "delete" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Tipo Establecimiento',
                    dataIndex: 'nombreTipoEstablecimiento',
                    key: 'nombreTipoEstablecimiento',
                    sorter: true
                },
                {
                    title: 'Dirección',
                    dataIndex: 'direccion',
                    key: 'direccion',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}